import React from "react";
import { StyledDropDown } from "./styled";

interface Props {
  options: {
    name: string;
    value: string;
  }[];
  placeholder?: string;
  label: string;
  name?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  type?: string;
}

const DropDown: React.FC<Props> = ({
  options,
  placeholder,
  label,
  name,
  value,
  onChange,
  type,
}) => {
  return (
    <StyledDropDown value={value}>
      <label htmlFor={name}>{label}</label>
      <select
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      >
        {options &&
          options.map((o, index) => {
            return (
              <option defaultValue={o.value} key={index} value={o.value}>
                {o.name}
              </option>
            );
          })}
      </select>
    </StyledDropDown>
  );
};

export default DropDown;
